<script lang='ts'>
    import {SelectSlider} from "@/Common";
    import type { ProgramFocusTypes } from "@/Common/constants";

    export let targetAthlete: ProgramFocusTypes
    export let athleteTypes: ProgramFocusTypes[]
    export let disabled = false
    export let focusPowerDuration: number
    export let onInput: () => void = () => {}

    let focusIndex = athleteTypes.indexOf(targetAthlete)
</script>

<div class="flex flex-col gap-1 items-center">
    <SelectSlider min=0 max={athleteTypes.length - 1} step=1 {disabled}
        bind:value={focusIndex}
        on:input={() => {
            targetAthlete = athleteTypes[focusIndex]
            onInput()
        }} 
    />
    <span class="text-center">
        {targetAthlete}
        <br/>
        <span class="text-sm text-slate-500">{focusPowerDuration} minute power</span>
    </span>
</div>